import { UI } from '../nextpage';

export class Alert {
    constructor(private NP: UI) {
        // Alert Shim Component
        // Hides the alert shim and adds an entry to the disabledAlerts object with the current timestamp.
        this.NP.registerEvent('hideAlertShim', (ev: Event) => {
            ev.preventDefault();
            this.NP.properties.disabledAlerts[window.location.pathname] = new Date().getTime();
            localStorage.setItem('disableAlerts', JSON.stringify(this.NP.properties.disabledAlerts));
            const alertShimWrap = document.querySelector('#alert-shim-wrap');
            if (alertShimWrap === null) {
                return;
            }
            this.NP.toggleAriaState(alertShimWrap, 'hidden', true);
        });

        // Shows the alert shim on this page if it is in the disabledAlerts object and removes the entry from the object.
        this.NP.registerEvent('showAlertShim', (ev: Event) => {
            ev.preventDefault();
            if (!this.NP.properties.disabledAlerts.hasOwnProperty(window.location.pathname)) {
                return;
            }
            delete this.NP.properties.disabledAlerts[window.location.pathname];
            localStorage.setItem('disableAlerts', JSON.stringify(this.NP.properties.disabledAlerts));
            const alertShimWrap = document.getElementById('alert-shim-wrap');
            if (alertShimWrap === null) {
                return;
            }
            this.NP.toggleAriaState(alertShimWrap, 'hidden', false);
        });


        this.NP.components.alert = (): void => {
            // Define the component function to enable alerts (no selector is allowed)
            const alertShimClose = document.getElementById('alert-shim-close');
            const alertShimWrap = document.getElementById('alert-shim-wrap');
            if (alertShimClose !== null) {
                alertShimClose.addEventListener('click', (ev: Event) => { this.NP.events.hideAlertShim(ev); });
            }
            // Binding the hide alert function
            document.querySelectorAll('.hide-alert').forEach((hider) => {
                hider.addEventListener('click', (ev: Event) => { this.NP.events.hideAlertShim(ev); });
            })
            
            // Binding the show alert function
            document.querySelectorAll('.show-alert').forEach((shower) => {
                shower.addEventListener('click', (ev: Event) => { this.NP.events.showAlertShim(ev) });
            });
            
            /*
                On page load we check the disabledAlerts object to see if it has this page in its properties. If so we check
                the timestamp of that property – if it has been more than one day the property is removed and the alert shim
                is left visible – otherwise the alert shim is hidden.
            */
            if (this.NP.properties.disabledAlerts.hasOwnProperty(window.location.pathname)) {
                const now = new Date().getTime();
                const disableTime = this.NP.properties.disabledAlerts[window.location.pathname];
                const disableDelta = now - disableTime;
                if (disableDelta >= this.NP.options.alertDisableDuration) {
                    delete this.NP.properties.disabledAlerts[window.location.pathname];
                    localStorage.setItem('disableAlerts', JSON.stringify(this.NP.properties.disabledAlerts));
                } else if (alertShimWrap !== null) {
                    this.NP.toggleAriaState(alertShimWrap, 'hidden', true);
                }
            }
            
            if (alertShimWrap !== null) {
                this.NP.mapAriaState(alertShimWrap, 'hidden');
            }
        }
    }
}